
export default function Testimonials() {
  const testimonials = [
    {
      name: "Andrea C. S",
      role: "Dpto. Pessoal",
      avatar: "ri-user-line",
      rating: 5,
      text: "Sistema muito bom, nos ajuda a esta sempre atualizado"
    },
    {
      name: "Danúbia",
      role: "Dpto. Pessoal",
      avatar: "ri-user-3-line",
      rating: 5,
      text: "Perfeito, amei"
    },
    {
      name: "Tatiana P.",
      role: "Dpto. Pessoal",
      avatar: "ri-user-2-line",
      rating: 5,
      text: "Excelente"
    },
    {
      name: "Rafael P.",
      role: "Dpto. Pessoal",
      avatar: "ri-user-4-line",
      rating: 5,
      text: "Ferramentas excelentes para o DP."
    },
    {
      name: "Ana Cláudia M. S",
      role: "Dpto. Pessoal",
      avatar: "ri-user-5-line",
      rating: 5,
      text: "Gostaria de parabenizar o sistema desenvolvido. É um sistema muito bem estruturado e fácil de usar"
    },
    {
      name: "Edinei S.",
      role: "Dpto. Pessoal",
      avatar: "ri-user-6-line",
      rating: 5,
      text: "Ficou ótimo o modelo de recibo, continuem assim."
    }
  ];

  return (
    <section id="depoimentos" className="py-20 md:py-32 px-4 bg-gradient-to-br from-teal-600 to-cyan-600 text-white">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black mb-6">
            O que estão dizendo sobre o CalculaDP
          </h2>
          <p className="text-xl text-white/90 max-w-3xl mx-auto">
            Mais de 500 profissionais já usam e aprovam nossa plataforma
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {testimonials.map((testimonial, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all transform hover:-translate-y-2"
            >
              {/* Rating */}
              <div className="flex mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                ))}
              </div>

              {/* Testimonial text */}
              <p className="text-white/90 mb-6 leading-relaxed italic">
                "{testimonial.text}"
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="bg-white/20 rounded-full p-3">
                  <i className={`${testimonial.avatar} text-xl text-white`}></i>
                </div>
                <div>
                  <div className="font-bold text-white">{testimonial.name}</div>
                  <div className="text-white/70 text-sm">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Social proof numbers */}
        <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-3xl font-black text-yellow-300 mb-2">+5.000</div>
              <div className="text-white/80">Usuários Ativos</div>
            </div>
            <div>
              <div className="text-3xl font-black text-yellow-300 mb-2">4.9⭐</div>
              <div className="text-white/80">Avaliação Média</div>
            </div>
            <div>
              <div className="text-3xl font-black text-yellow-300 mb-2">98%</div>
              <div className="text-white/80">Taxa de Satisfação</div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <h3 className="text-2xl md:text-3xl font-bold mb-6">
            Junte-se a milhares de profissionais satisfeitos
          </h3>
          <button className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 px-10 py-4 rounded-xl text-lg font-bold shadow-lg hover:shadow-xl transition-all transform hover:scale-105 whitespace-nowrap">
            <i className="ri-star-line mr-2"></i>
            Quero Fazer Parte Também
          </button>
        </div>
      </div>
    </section>
  );
}
